import useRequest from '@/websdk/utils/request';

export default function () {
  const { data } = useRequest({
    url: '/api/material_types',
    name: 'GET_MATERIAL_TYPES',
  });

  return [data || []];
}
